import { useReduxState } from 'hooks';
import { getAvailableUserPermissions } from 'lib/users';
import { Search } from 'components/common';
import { DropdownSelectable } from 'components/common/dropdown';
import { AdminsFilters } from './Admins';

interface Props {
  updateFilters: (params: Partial<AdminsFilters>) => void;
}

const AdminsSubHeader = ({ updateFilters }: Props) => {
  const { messages, serverConfig } = useReduxState();

  const permissions = getAvailableUserPermissions({ messages, serverConfig });

  return (
    <div className="subheader">
      <div className="search">
        <div className="search-content">
          <Search
            onSearch={({ search }) => updateFilters({ search })}
            placeholder={messages.usersSearchUsers}
          />
        </div>
      </div>
      <div className="role">
        <DropdownSelectable
          category="lighter"
          defaultText={`${messages.commonSelect}...`}
          defaultValue={'all'}
          dropdownTextMinWidth="120px"
          onChange={(role) => updateFilters({ role })}
          options={[
            {
              text: messages.usersAllRoles,
              value: 'all'
            },
            {
              text: messages.usersSuperadmin,
              value: 'superadmin'
            },
            {
              text: messages.usersAdmin,
              value: 'admin'
            }
          ]}
          showSelectedText={true}
          size="header"
          titleMaxWidth={200}
        />
      </div>
      <div className="permission">
        <DropdownSelectable
          category="lighter"
          defaultText={`${messages.commonSelect}...`}
          defaultValue={'all'}
          dropdownTextMinWidth="120px"
          onChange={(permission) =>
            updateFilters({
              permission: permission as AdminsFilters['permission']
            })
          }
          options={[
            {
              text: messages.usersAllPermissions,
              value: 'all'
            },
            ...Object.keys(permissions).map((permission) => ({
              text: permissions[permission]?.label,
              value: permission
            }))
          ]}
          showSelectedText={true}
          size="header"
          titleMaxWidth={200}
        />
      </div>

      <style jsx>{`
        .subheader {
          align-items: center;
          display: flex;
          gap: 15px;
          flex-wrap: wrap;
          width: 100%;
        }
        .search {
          flex-grow: 1;
        }
        .search-content {
          max-width: 100%;
          width: 240px;
        }
      `}</style>
    </div>
  );
};

export default AdminsSubHeader;
